module.exports = __webpack_public_path__ + "static/media/2section.fb1f2837.png";